import EditOffIcon from '@mui/icons-material/EditOff'
import classNames from 'classnames'
import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { FC } from 'react'
import { useAppSelector } from 'store/hooks'

import { OrderStepConfirmProductParam } from '../orderStepConfirmProductParam'

import style from './OrderStepConfirmProducts.module.scss'

interface IOrderStepConfirmProducts {
  product: orderFormSpace.Product
}

export const OrderStepConfirmProducts: FC<IOrderStepConfirmProducts> = ({
  product,
}) => {
  const currentEditForm = useAppSelector(
    state => state.orderForm.currentEditForm,
  )
  const params = useAppSelector(
    state => state.orderForm.forms[currentEditForm].params,
  )
  const productParams = params.filter(item => item.productId === product.id)

  if (productParams.length > 0) {
    return (
      <div className={style.product}>
        <span className='h2'>{product.name}</span>
        <span className={classNames('h4', style.paramsTitle)}>Параметры </span>
        <div className={style.paramsList}>
          {productParams
            .sort((a, b) => a.id - b.id)
            .map(item => (
              <OrderStepConfirmProductParam key={item.id} param={item} />
            ))}
        </div>
      </div>
    )
  } else {
    return (
      <div className={style.product}>
        <span className='h2'>{product.name}</span>
        <div className={style.outParams}>
          <EditOffIcon fontSize='inherit' className={style.editOffIcon} />
          <span>Уточнение параметров не требуется</span>
        </div>
      </div>
    )
  }
}
